import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, BookCheck, ExternalLink, Copy } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';
import { fmtDate } from '../../lib/dates';

export const ResearchPanel = ({ matter, initial }) => {
  const { api } = useAuth();
  const [data, setData] = useState(initial);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (initial) setData(initial); }, [initial]);
  const run = async () => {
    setBusy(true);
    try { setData(await runAiJob(api, `/cerebro/matters/${matter.id}/research`, {}, { timeout: 240000 })); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success('Cita copiada'); };
  return (
    <div className="space-y-3 pt-3" data-testid="research-panel">
      <button data-testid="research-run-btn" onClick={run} disabled={busy} className="w-full rounded-lg bg-sky-500 py-2 text-sm font-semibold text-slate-950 hover:bg-sky-400 disabled:opacity-60 flex items-center justify-center gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BookCheck className="h-4 w-4" />}{busy ? 'Buscando precedentes del país...' : 'Buscar precedentes verificados'}
      </button>
      <p className="text-[11px] text-slate-500">Solo se muestran fallos registrados en la plataforma con su fuente; la IA no puede inventar sentencias.</p>
      {data?.note && <p data-testid="research-note" className="text-xs text-amber-200">{data.note}</p>}
      {data && !data.note && !data.precedentes?.length && <p data-testid="research-empty" className="text-xs text-amber-200">Ninguno de los fallos registrados de este país es aplicable a este caso todavía. La búsqueda nocturna seguirá sumando sentencias.</p>}
      {data?.precedentes?.map((p) => (
        <div key={p.id} data-testid={`research-item-${p.id}`} className="rounded-xl border border-slate-800 bg-slate-900/70 p-3 space-y-1">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-semibold text-white">{p.case_number}</p>
            <span className={`rounded-full px-2 py-0.5 text-[10px] ${p.uso === 'en_contra' ? 'bg-red-500/20 text-red-300' : 'bg-emerald-500/20 text-emerald-300'}`}>{p.uso === 'en_contra' ? 'En contra: anticípalo' : 'A favor'}</span>
          </div>
          <p className="text-xs text-slate-500">{p.court_name} · {fmtDate(p.ruling_date)} · {p.outcome}</p>
          <p className="text-xs text-slate-300">{p.por_que}</p>
          {p.como_citarlo && <button onClick={() => copy(p.como_citarlo)} className="text-left text-xs text-sky-300 hover:underline flex gap-1"><Copy className="h-3 w-3 mt-0.5 shrink-0" />{p.como_citarlo}</button>}
          {p.source_url && <a href={p.source_url} target="_blank" rel="noreferrer" className="text-[11px] text-slate-400 hover:text-white flex items-center gap-1"><ExternalLink className="h-3 w-3" />Ver fuente</a>}
        </div>
      ))}
    </div>
  );
};
